import { useEffect, useState } from 'react';
import '../CSS/private/LoginTemplate.css';

import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, logInWithEmailAndPassword, sendPasswordReset } from "../firebase/firebase_setup";
import { useNavigate } from 'react-router-dom';
import isNarrow from '../functions/isNarrow';

/**
 * @param {*} props - appName       = the name of the current app
 *                  - logo          = the logo of the current app
 *                  - redirect      = location to redirect the user to after a successful login
 *                  - accentColour  = the primary accent colour for the app
 */
function LoginTemplate(props) {

  // Set to either 'login' or 'forgot-password'
  const [status, setStatus] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginFailureMessage, setLoginFailureMessage] = useState("");
  const [fpFailureMessage, setFpFailureMessage] = useState("");
  const [fpSuccessMessage, setFpSuccessMessage] = useState("");
  const [working, setWorking] = useState(false);
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();


  const [narrow, setNarrow] = useState(isNarrow(document.clientWidth));
  window.addEventListener("resize", function(event) {
    setNarrow(isNarrow(document.body.clientWidth));
  });


  // Check if the user is already signed in
  useEffect(() => {
    if (loading) return;
    if (user) navigate(props.redirect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading]);


  if(status === 'login') {
    return (
      <div className='slp-logintemplate-container slp-logintemplate-login-animation' style={narrow? ({...{width: '300px'}, ...{marginLeft: '-170px'}}) : ({...{width: '400px'}, ...{marginLeft: '-220px'}})}>
        <img src={props.logo} width='75px' alt='app logo' />
        <h1>Shoru Sign-In</h1>
        <p style={{width: '75%'}}>
          Sign in with your Shoru account to proceed to {props.appName}
        </p>
        <form onSubmit={(e) => {
          e.preventDefault();
          logInWithEmailAndPassword(email, password, setWorking, setLoginFailureMessage)
        }}>
          <input className='slp-logintemplate-input' type='text' value={email} onChange={(e) => setEmail(e.target.value.trim())} placeholder='Email' />
          <input className='slp-logintemplate-input' type='password' value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Password' />
          <button className='slp-logintemplate-button' disabled={working} style={{...{backgroundColor: working ? '#555' : props.accentColour}}} type='submit'>Sign In</button>
        </form>
        <u className='slp-logintemplate-text-link' style={{color: props.accentColour}} onClick={() => setStatus('forgot-password')}>Forgotten Password?</u>
        <div className='slp-logintemplate-failure-message'>{loginFailureMessage}</div>
      </div>
    )
  }
  else {
    return (
      <div className='slp-logintemplate-container slp-logintemplate-forgot-password-animation' style={narrow? ({...{width: '300px'}, ...{marginLeft: '-170px'}}) : ({...{width: '400px'}, ...{marginLeft: '-220px'}})}>
        <img src={props.logo} width='75px' alt='nova suite logo' />
        <h1>Account Recovery</h1>
        <p style={{width: '75%'}}>
          Enter your email to reset your password. You 
          will be sent an email with a link allowing you 
          to do this.
        </p>
        <form onSubmit={(e) => {
          e.preventDefault();
          sendPasswordReset(email, setWorking, setFpFailureMessage, setFpSuccessMessage)
        }}>
          <input className='slp-logintemplate-input' type='text' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Email' />
          <button className='slp-logintemplate-button' disabled={working} style={{...{backgroundColor: working ? '#555' : props.accentColour}}} type='submit'>Reset Password</button>
        </form>
        <u className='slp-logintemplate-text-link' style={{color: props.accentColour}} onClick={() => setStatus('login')}>Back to login</u>
        <div className='slp-logintemplate-failure-message'>{fpFailureMessage}</div>
        <div className='slp-logintemplate-success-message'>{fpSuccessMessage}</div>
      </div>
    )
  }
}

export default LoginTemplate;